import React, { useContext } from "react";
import { useMediaQuery } from "react-responsive";

import MapContext from "../context/MapContext";
import CategoryListItem from "./CategoryListItem";
import MenuButton from "./MenuButton";

import { Sizes } from "../../../styles";
import LocationPopout from "./LocationPopout";

// The most parent component of the filterbar
// it handles the rendering of the menu categories, menu-items and the details popout

const Filterbar = () => {
	const isDesktop = useMediaQuery({
		query: `(min-width: ${Sizes.screens.large})`,
	});

	const {
		data: { locations, selectedCategory, errorMsg, isNewFood, highlightedLocation },
		actions: { handleCategory, handleClickMenuItem },
	} = useContext(MapContext);

	const renderMapLink = () => {
		return (
			<div className="filter-bar__new-this-year">
				<a
					href="https://www.theex.com/map"
					aria-label="view general map"
				>
					Explore CNE Map
				</a>
			</div>
		)
	}

	const renderNewFoodMapLink = () => {
		return (
			<div className="filter-bar__new-this-year">
				<h3>New this year!</h3>
				<a
					href="https://www.theex.com/map/new-food"
					aria-label="explore new food map"
				>
					Explore featured foods map
				</a>
			</div>
		)
	}

	if (!locations)
		return (
			<div className="filter-bar">
				<div className="filter-bar__container">
					{errorMsg && (
						<h3 className="filter-bar__category__header__title--error">
							There was an error. Please try again
						</h3>
					)}
				</div>
			</div>
		);

	const categoriesInAlphabeticalOrder = Object.keys(locations).sort();

	const renderCategoriesDesktop = () => {
		return (
			<>
				<h2 className={`filter-bar__title ${isNewFood && "new-food"}`}>{isNewFood? 'Featured Foods Map': 'Interactive Map'}</h2>
				{isNewFood? renderMapLink(): renderNewFoodMapLink()}
				{categoriesInAlphabeticalOrder.map((category) => {
					const selectedCategoryIndicator =
						selectedCategory === category || highlightedLocation === category? "show" : "";
					const categoryName = locations[category][0].categoryName;

					return (
						<div key={category} className="filter-bar__category">
							<span
								className={`filter-bar__category__shape--1 ${selectedCategoryIndicator}`}
							></span>
							<span
								className={`filter-bar__category__shape--2 ${selectedCategoryIndicator}`}
							></span>
							<MenuButton
								handleClick={() => handleCategory(category)}
								isOpen={selectedCategory === category}
								category={category}
								categoryName={categoryName}
							/>
							<ul
								className={`filter-bar__category__list ${
									category === selectedCategory || highlightedLocation === category? "show-menu" : ""
								}`}
							>
								{locations[category].map((option) => {
									return (
										<CategoryListItem
											key={`${option.name}-${category}`}
											option={option}
										/>
									);
								})}
							</ul>
						</div>
					);
				})}
			</>
		);
	};
	const handleClick = (e, category) => {
		e.preventDefault();

		if (category === selectedCategory) return;

		handleCategory(category);
	};
	const handleSelect = (e) => {

		if (!selectedCategory) return;
		//  the name of the location is passed as the value
		const selectedItem = locations[selectedCategory].find(
			(location) => location.name === e.target.value
		);

		if (!selectedItem) return null;

		handleClickMenuItem(selectedItem);
	};

	const renderCategoriesMobile = () => {
		return (
			<>
				<div>
					<h2 className={`filter-bar__title ${isNewFood && "new-food"}`}>{isNewFood? 'Featured Foods Map': 'Interactive Map'}</h2>
					{isNewFood? renderMapLink(): renderNewFoodMapLink()}
				</div>
				<div className="filter-bar__categories">
					{categoriesInAlphabeticalOrder.map((category) => {
						const categoryName = locations[category][0].categoryName;

						return (
							<button
								aria-label={`View locations of category ${category}`}
								onClick={(e) => handleClick(e, category)}
								key={category}
								className={`filter-bar__categories__category ${
									category === selectedCategory ? "selected" : ""
								}`}
								dangerouslySetInnerHTML={{ __html: categoryName }}
							/>
						);
					})}
				</div>
				<div className="filter-bar__dropdown">
					<select
						className="filter-bar__dropdown__select"
						value=""
						onChange={handleSelect}
					>
						<option value="" hidden disabled>
							Select location
						</option>
						{selectedCategory &&
							locations[selectedCategory].map((option) => {
								return (
									<option dangerouslySetInnerHTML={{ __html: option.name }} value={option.name} key={option.name}/>
								);
							})}
					</select>
				</div>
			</>
		);
	};

	return (
		<>
			<div className="filter-bar">
				<div className="filter-bar__container">
					{isDesktop ? renderCategoriesDesktop() : renderCategoriesMobile()}
				</div>
			</div>
			<LocationPopout />
		</>
	);
};

export default Filterbar;
